import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faStar } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../config/constants';
function SingleCourse() {
	const { id } = useParams();
	const [course, setCourse] = useState(null);
	const [message, setMessage] = useState('');
	const [courseDetails, setCourseDetails] = useState('Description');
	const [visibleLesson, setVisibleLesson] = useState(null);
	const token = Cookies.get('token');
	const navigate = useNavigate();
	const baseUrl = BASE_URL; // Fetch course data
	useEffect(() => {
		fetch(`${baseUrl}/api/v1/courses/${id}`)
			.then((res) => res.json())
			.then((data) => setCourse(data))
			.catch((err) => console.error('Error fetching course data:', err));
	}, [id]);

	// Handle course detail tab change
	const handleCourseDetail = (e) => {
		if (courseDetails !== e.target.value) {
			setCourseDetails(e.target.value);
		}
	};

	// Handle course enrollment
	const handleEnrollCourse = async (e) => {
		e.preventDefault();
		if (!token) {
			setMessage('Please log in.');
			setTimeout(() => {
				navigate('/login');
			}, 2000);
			return;
		}

		try {
			const response = await fetch(`${baseUrl}/api/v1/my-learning/me`, {
				method: 'POST',
				body: JSON.stringify({ courseId: +id }),
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			});
			const data = await response.json();
			if (response.ok) {
				console.log(data);
				if (data?.redirectUrl) {
					console.log('ssssssssssssssssss', data.redirectUrl);
					setMessage('Redirecting to contact us page...');
					setTimeout(() => {
						navigate('/Contact'); // Redirect to packages page
					}, 2000);
				}
				if (
					data.paymentType === 'FREE' ||
					data.paymentType === 'SUBSCRIPTION'
				) {
					setMessage('Enrolled Successfully');
					setTimeout(() => {
						navigate('/my-learning');
					}, 2000);
				}
			} else {
				setMessage(data.myLearning);
				if (data.myLearning === 'User already learning this course') {
					setTimeout(() => {
						navigate(`/my-learning/${id}`);
					}, 2000);
				}
			}
		} catch (error) {
			setMessage(error.message);
		}
	};

	// Toggle lesson description visibility
	const handleToggleDescription = (lessonId) => {
		setVisibleLesson((prev) => (prev === lessonId ? null : lessonId));
	};

	return (
		<main>
			{course ? (
				<>
					{/* Course Hero Section */}
					<section className='bg-main h-[30vh] md:h-[50vh] flex justify-center items-center'>
						<h2 className='text-2xl md:text-5xl text-white font-semibold text-center'>
							{course.name}
						</h2>
					</section>

					{/* Course Details Section */}
					<div className='container flex flex-col md:flex-row my-12'>
						{/* Left Section: Course Content */}
						<section className='container flex flex-col my-12 gap-6 md:w-2/3 items-start'>
							<div className='informationAboutCourse flex flex-col gap-4 w-full'>
								<header className='flex gap-2 items-center'>
									<h2 className='text-main font-semibold text-md'>
										{Array.isArray(course.teachers)
											? course.teachers
													.map((teacher) => teacher.name)
													.join(', ')
											: course.teachers?.name ||
											  course.teachers ||
											  'No teachers available'}
									</h2>
								</header>
								<p className='shortDescription text-main text-2xl font-semibold md:hover:text-secondary transition-all duration-500 cursor-pointer'>
									{course.shortDescription}
								</p>
								<div className='videoOfTheCourse w-full h-full rounded-xl overflow-hidden'>
									{course.video ? (
										<iframe
											id='youtube-2551'
											title='Lesson Video'
											src={`https://www.youtube.com/embed/${course.video.URL.split(
												'/'
											).pop()}?controls=1&modestbranding=1&rel=0&showinfo=0&disablekb=1&playsinline=1&cc_load_policy=0&cc_lang_pref=auto`}
											frameBorder='0'
											allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
											sandbox='allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-presentation'
											className='w-full h-72'></iframe>
									) : (
										<p className='text-center text-main'>
											No course image available.
										</p>
									)}
								</div>
							</div>

							{/* Course Details Tabs */}
							<div className='courseDetails bg-[#cbd6e2] w-full flex p-0.5 gap-0.5'>
								<button
									className={`text-main font-semibold p-2 w-1/3 outline-none bg-${
										courseDetails === 'Description' ? 'secondary' : 'white'
									}`}
									onClick={handleCourseDetail}
									value='Description'>
									Description
								</button>
								<button
									className={`text-main font-semibold p-2 w-1/3 outline-none bg-${
										courseDetails === 'overview' ? 'secondary' : 'white'
									}`}
									onClick={handleCourseDetail}
									value='overview'>
									Overview
								</button>
								<button
									className={`text-main font-semibold p-2 w-1/3 outline-none bg-${
										courseDetails === 'Review' ? 'secondary' : 'white'
									}`}
									onClick={handleCourseDetail}
									value='Review'>
									Review
								</button>
							</div>

							{/* Course Description */}
							{courseDetails === 'Description' ? (
								<p className='longDescription text-textColor text-md'>
									{course.longDescription}
								</p>
							) : courseDetails === 'overview' ? (
								<div className='longDescription text-textColor text-md flex flex-col gap-3'>
									<h3 className='text-main font-bold text-2xl'>Overview</h3>
									<p>{course.overview}</p>
									{course.lessons &&
										course.lessons.map((lesson) => (
											<div
												key={lesson.id}
												className='mb-2'>
												<div
													className='text-main text-md md:text-xl font-bold flex justify-between gap-1 items-center cursor-pointer'
													onClick={() => handleToggleDescription(lesson.id)}>
													{lesson.index}.{lesson.title}
													<FontAwesomeIcon
														icon={faEye}
														className={`text-md md:text-2xl transition-all duration-200 ${
															visibleLesson === lesson.id
																? 'text-secondary'
																: 'text-textColor'
														}`}
													/>
												</div>
												{visibleLesson === lesson.id && (
													<p className='mt-2 text-textColor'>
														{lesson.description}
													</p>
												)}
											</div>
										))}
								</div>
							) : courseDetails === 'Review' ? (
								<div className='longDescription text-textColor border-2 border-solid w-full flex flex-col items-center p-10 gap-4'>
									<h2 className='text-main text-4xl font-bold'>
										{course.rate && course.rate.toFixed(1)}
									</h2>
									<p className='flex gap-1'>
										{course.rate &&
											Array(Math.round(course.rate))
												.fill()
												.map((_, index) => (
													<FontAwesomeIcon
														key={index}
														icon={faStar}
														className='text-blue-500 text-sm'
													/>
												))}
									</p>
								</div>
							) : null}
						</section>

						{/* Right Section: Course Features */}
						<aside className='md:my-12 h-fit md:w-1/3 border-[#cbd6e2] border-solid border-[1px]'>
							<header className='border-b-[#cbd6e2] border-b-solid border-b-[1px] p-4'>
								<h2 className='font-bold text-main text-xl'>Course Features</h2>
							</header>
							<div className='flex flex-col gap-3 p-4 mb-4'>
								<p className='text-md text-main'>
									<span className='font-semibold'>Enrolled :</span>{' '}
									{course.enrolled} students
								</p>
								<p className='text-md text-main'>
									<span className='font-semibold'>Duration :</span>{' '}
									{course.duration} hours
								</p>
								<p className='text-md text-main'>
									<span className='font-semibold'>Lectures :</span>{' '}
									{course.lessons?.length || 0}
								</p>
								<p className='text-md text-main'>
									<span className='font-semibold'>Categories :</span>{' '}
									{course.category}
								</p>
								<p className='text-md text-main'>
									<span className='font-semibold'>Tags :</span>
									{course.tags?.length > 0
										? course.tags.map((tag, index) => (
												<span key={index}>
													{tag.name}
													{index < course.tags.length - 1 && ', '}
												</span>
										  ))
										: 'No tags available'}
								</p>
							</div>
							<div className='bg-[#f0f4f9] py-8 px-4 flex flex-col justify-center items-center gap-4'>
								<p className='text-md text-main text-lg'>
									<span className='font-semibold'>Price: </span>
									{course.price} $
								</p>
								<button
									className='text-white bg-secondary w-full rounded-full p-3 text-main'
									onClick={handleEnrollCourse}>
									Enroll Now
								</button>
								{message === 'User already learning this course' ? (
									<p className='text-green-600'>
										You have already registered for this course
									</p>
								) : message === 'Enrolled Successfully' ? (
									<p className='text-green-600'>Enrolled Successfully</p>
								) : message === 'Redirecting to payment gateway...' ? (
									<p className='text-blue-600'>{message}</p>
								) : message === 'Redirecting to Packages page...' ? (
									<p className='text-blue-600'>{message}</p>
								) : (
									<p className='text-red-600'>{message}</p>
								)}
							</div>
						</aside>
					</div>
				</>
			) : (
				<div className='flex justify-center items-center h-screen'>
					<p className='text-2xl font-semibold text-main'>Loading...</p>
				</div>
			)}
		</main>
	);
}

export default SingleCourse;
